/**
 * Resolve any course image URL (thumbnail / banner) into an absolute browser URL.
 *
 * Handles four cases:
 *  1. Empty / null → ""
 *  2. Absolute URL (http/https/data) → returned as-is
 *  3. Relative backend path starting with "/api/..." → prefixed with REACT_APP_BACKEND_URL
 *  4. Raw storage path (legacy) like "steward-learning-cloud/course_thumbnails/..."
 *     → wrapped in the public image proxy endpoint
 */
const BACKEND_BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export function resolveImg(u) {
  if (!u || typeof u !== "string") return "";
  if (u.startsWith("http://") || u.startsWith("https://") || u.startsWith("data:")) return u;
  if (u.startsWith("/")) return `${BACKEND_BASE}${u}`;
  if (u.startsWith("steward-learning-cloud/branding/")) {
    // Branding assets (institute logos, banners) live behind the auth-
    // protected /api/files proxy — the browser passes the auth cookie
    // automatically on same-origin img requests.
    return `${BACKEND_BASE}/api/files/${u}`;
  }
  if (u.startsWith("steward-learning-cloud/")) {
    return `${BACKEND_BASE}/api/public/course-image?path=${encodeURIComponent(u)}`;
  }
  return u;
}
